const SET_ITEMS = (state, items) => {
  Object.assign(state, { items })
}

const RESET = state => {
  Object.assign(state, { items: {} })
}

export default {
  SET_ITEMS,
  RESET
}
